import { useModalContext } from 'utils/contexts/modal';
import { ThirdPartyIntegration } from '../types';

export enum MODAL_ACTION {
  CREATE_THIRD_PARTY_INTEGRATION = 'create-third-party-integration',
  EDIT_THIRD_PARTY_INTEGRATION = 'edit-third-party-integration',
  DELETE_THIRD_PARTY_INTEGRATION = 'delete-third-party-integration',
}

export interface ModalState {
  action: MODAL_ACTION;
  thirdPartyIntegration?: ThirdPartyIntegration;
}

export type ModalContextState = {
  showModal: (modalState: ModalState) => void;
  hideModal: () => void;
  modalState: ModalState | null;
};

export const useModalsContext = () => {
  const { showModal, hideModal, modalState } = useModalContext<ModalState>();

  const showCreateThirdPartyIntegrationModal = () =>
    showModal({
      action: MODAL_ACTION.CREATE_THIRD_PARTY_INTEGRATION,
    });

  const showEditThirdPartyIntegrationModal = (thirdPartyIntegration: ThirdPartyIntegration) =>
    showModal({
      action: MODAL_ACTION.EDIT_THIRD_PARTY_INTEGRATION,
      thirdPartyIntegration,
    });

  const showDeleteThirdPartyIntegrationModal = (thirdPartyIntegration: ThirdPartyIntegration) =>
    showModal({
      action: MODAL_ACTION.DELETE_THIRD_PARTY_INTEGRATION,
      thirdPartyIntegration,
    });

  return {
    showCreateThirdPartyIntegrationModal,
    showEditThirdPartyIntegrationModal,
    showDeleteThirdPartyIntegrationModal,
    hideModal,
    modalState,
  };
};
